/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicalPersonFinancialGroupResponse
 */
export interface MedicalPersonFinancialGroupResponse {
    /**
     * the unique identifier of medical person
     * @type {string}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    id?: string;
    /**
     * the firstname and lastname of medical person
     * @type {string}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    name?: string;
    /**
     * the active status of the medical person
     * @type {boolean}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    active?: boolean;
    /**
     * the role of the medical person
     * @type {string}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    role?: string;
    /**
     * the owner status of the medical person
     * @type {boolean}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    isOwner?: boolean;
    /**
     * list of permissions granted to this person in the group
     * @type {Array<string>}
     * @memberof MedicalPersonFinancialGroupResponse
     */
    permissions?: Array<MedicalPersonFinancialGroupResponsePermissionsEnum>;
}


/**
 * @export
 */
export const MedicalPersonFinancialGroupResponsePermissionsEnum = {
    CreateBills: 'CREATE_BILLS',
    AddCancelTransactions: 'ADD_CANCEL_TRANSACTIONS',
    AddPaymentTransactions: 'ADD_PAYMENT_TRANSACTIONS',
    ExportBills: 'EXPORT_BILLS',
    ModifyTransactions: 'MODIFY_TRANSACTIONS'
} as const;
export type MedicalPersonFinancialGroupResponsePermissionsEnum = typeof MedicalPersonFinancialGroupResponsePermissionsEnum[keyof typeof MedicalPersonFinancialGroupResponsePermissionsEnum];


/**
 * Check if a given object implements the MedicalPersonFinancialGroupResponse interface.
 */
export function instanceOfMedicalPersonFinancialGroupResponse(value: object): value is MedicalPersonFinancialGroupResponse {
    return true;
}

export function MedicalPersonFinancialGroupResponseFromJSON(json: any): MedicalPersonFinancialGroupResponse {
    return MedicalPersonFinancialGroupResponseFromJSONTyped(json, false);
}

export function MedicalPersonFinancialGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalPersonFinancialGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
        'role': json['role'] == null ? undefined : json['role'],
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function MedicalPersonFinancialGroupResponseToJSON(json: any): MedicalPersonFinancialGroupResponse {
    return MedicalPersonFinancialGroupResponseToJSONTyped(json, false);
}

export function MedicalPersonFinancialGroupResponseToJSONTyped(value?: MedicalPersonFinancialGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'role': value['role'],
        'isOwner': value['isOwner'],
        'permissions': value['permissions'],
    };
}

